import { fetchFromOldApi } from '~/services/Http';

export type Performance = {
  fEmpId: number;
  fPerfTotalScore: number;
  fPerfEvalResult: string;
  fTransactionComment: string;
  fTransactionEnteredTime: string;
};

export const getEmpPerformance = (empId: number): Promise<Performance[]> => {
  return fetchFromOldApi(`/json/employee/${empId}/performance/summary`)
    .then((r) => r.json())
    .catch((error) => {
      console.error(error.message);
    });
};
